import { toast } from 'react-toastify'
import { ky, useSWRMutation, parseKyError } from './client'

export const AccessLevels = [
  // { value: "super", label: "Super Admin" },
  // { value: "manage", label: "Coordinator" },
  { value: 'admin', label: 'Admin' },
  { value: 'audit', label: 'Audit' },
  { value: 'report', label: 'Report' }
]

export const AuthMethods = [
  {
    value: 'password',
    label: 'Password'
  },
  { value: 'saml', label: 'SSO' }
]

/**
 * Fetches the coordinator user list.
 *
 * @param {Object} pagination - Pagination details.
 * @param {string} pagination.search - An email/name search string.
 * @param {number} pagination.pageNumber - Page number.
 * @param {number} pagination.pageSize - Page size.
 * @param {boolean} active - filter for active/inactive users, all users is undefined.
 *
 * @returns
 */
export const getUserList = async (pagination, active) => {
  try {
    const request = await ky.get('coordinator/users/all', {
      searchParams: { ...pagination, active }
    })
    return await request.json()
  } catch (error) {
    console.log(error)
    toast('Unable to show users list. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: []
    }
  }
}

/**
 * @param {object} props
 * @param {(error: import('./client').KyError) => Promise<void> | void} [props.onError]
 * @param {() => Promise<void> | void} [props.onSuccess]
 *  */
export const useUpdateUser = ({ onError, onSuccess }) => {
  /**
   * @param {string} url
   * @param {{ arg: import('./coordinator.types').UpdateUserInput }} options
   */
  const fetcher = async (url, { arg }) => {
    await ky.post(url, {
      json: { ...arg }
    })
    return arg.id
  }

  const { trigger, data, error, isMutating } = useSWRMutation('coordinator/users/update', fetcher, {
    throwOnError: false,
    onError: async (error) => {
      const parsedError = await parseKyError(error)
      onError?.(parsedError)
    },
    onSuccess
  })

  return { updateUser: trigger, data, error, isMutating }
}

/**
 * @param {object} props
 * @param {(error: import('./client').KyError) => Promise<void> | void} [props.onError]
 * @param {() => Promise<void> | void} [props.onSuccess]
 *  */
export const useAddUser = ({ onError, onSuccess }) => {
  /**
   * @param {string} url
   * @param {{ arg: import('./coordinator.types').AddUserInput }} options
   */
  const fetcher = async (url, { arg }) => {
    const response = await ky.post(url, {
      json: { ...arg }
    })
    return await response.json()
  }

  const { trigger, data, error, isMutating } = useSWRMutation('coordinator/users/add', fetcher, {
    throwOnError: false,
    onError: async (error) => {
      const parsedError = await parseKyError(error)
      onError?.(parsedError)
    },
    onSuccess
  })

  return { addUser: trigger, data, error, isMutating }
}

/*
 * Fetches a list of plans with multiple assignments for moderation.
 *
 * @param {Object} pagination - Pagination details.
 * @param {string} pagination.search - An email/name search string.
 * @param {number} pagination.pageNumber - Page number.
 * @param {number} pagination.pageSize - Page size.
 *
 * @returns
 */
export const getModerateList = async (pagination) => {
  try {
    const request = await ky.get('coordinator/moderated', {
      searchParams: pagination
    })
    return await request.json()
  } catch (error) {
    console.log('in error')
    console.log(error)
    toast('Unable to show moderated reviews. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: []
    }
  }
}
